import type { DropdownPlacement, DropdownTrigger } from "./Dropdown.type";

// Careful, couple with Antd dropdown placement
export const DROPDOWN_PLACEMENT = {
  BOTTOM_LEFT: "bottomLeft",
  BOTTOM_RIGHT: "bottomRight",
  BOTTOM: "bottom",
  TOP_LEFT: "topLeft",
  TOP_RIGHT: "topRight",
  TOP: "top",
} as const;

export const DROPDOWN_PLACEMENT_VALUES = Object.values(
  DROPDOWN_PLACEMENT
) as DropdownPlacement[]; // TODO: remove this after TS migration

// Careful, couple with Antd dropdown trigger
export const DROPDOWN_TRIGGER = {
  CLICK: "click",
  CONTEXT_MENU: "contextMenu",
  HOVER: "hover",
} as const;

export const DROPDOWN_TRIGGER_VALUES = Object.values(
  DROPDOWN_TRIGGER
) as DropdownTrigger[]; // TODO: remove this after TS migration
